import api from "./ApiService";

export class ZabbixApiService {
  static async acknowledgeProblem(eventId: string, ackMessage: string, zabbixId: number, companyId: number) {
    const data = {
      eventids: [eventId],
      message: ackMessage,
      zabbixId: zabbixId,
      company: {
        id: companyId
      }
    }

    const response = await api.post(`/zabbix/acknowledge-problem`, data);
    return response.data.result;
  }

  static async addMessageToProblem(eventId: string, ackMessage: string, zabbixId: number, companyId: number) {
    const data = {
      eventids: [eventId],
      message: ackMessage,
      zabbixId: zabbixId,
      company: {
        id: companyId
      }
    }

    const response = await api.post(`/zabbix/add-problem-message`, data);
    return response.data.result;
  }
  
  static async getHosts(companyId: string) {
    const response = await api.get(`/zabbix-triggers/${companyId}/hosts`);
    return response.data;
  }

  static async getHostItems(companyId: string, hostId: string) {
    const response = await api.get(`/zabbix-triggers/${companyId}/hosts/${hostId}/items`);
    return response.data;
  }

  static async getItemTriggers(companyId: string, itemId: string) {
    const response = await api.get(`/zabbix-triggers/${companyId}/items/${itemId}/triggers`);
    return response.data;
  }

  static async getHostById(companyId: string, hostId: string) {
    const response = await api.get(`/zabbix-triggers/${companyId}/hosts/${hostId}`);
    return response.data;
  }

  static async getItemById(companyId: string, itemId: string) {
    const response = await api.get(`/zabbix-triggers/${companyId}/items/${itemId}`);
    return response.data;
  }

  static async getTriggerById(companyId: string, triggerId: string) {
    const response = await api.get(`/zabbix-triggers/${companyId}/triggers/${triggerId}`);
    return response.data;
  }
}
